
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { getDataFullUser } from "./AxiosApi/userApi";

// دریافت توکن از لوکال استوریج
const accessToken = localStorage.getItem("COact");

// تابع برای دیکد کردن توکن و استخراج اطلاعات
function decodeToken(token) {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

// چک کردن اعتبار توکن
function checkTokenValidity(token) {
  const decoded = decodeToken(token);
  return decoded;
}

// استخراج اطلاعات دیکد شده (در صورتی که توکن موجود باشد)
const decodedUser = accessToken ? decodeToken(accessToken) : null;

const initialState = {
  accessToken: accessToken || null,
  isAuthenticated: accessToken ? checkTokenValidity(accessToken) : false,
  user: null,
  decodedUser: decodedUser || null, // ذخیره اطلاعات دیکد شده‌ی یوزر
  status: "idle",
  error: null,
};

// console.log(accessToken);

// درخواست فچ اطلاعات یوزر
export const fetchUserData = createAsyncThunk("auth/fetchUserData", async () => {
  // const state = getState();
  // const token = state.auth.accessToken;
  // const decUser = state.auth.decodedUser;
  // const decodedUser = state.auth.decodedUser; // گرفتن اطلاعات دیکد شده
  // console.log(decUser);
  // console.log(token);
  // const decodedUser = decodeToken(token)

  // if (!token) console.log("token error");

  //این برای این بخش هست که ما توکن را دیکد میکنیم و تا  به آیدی کاربر دسترسی داشته باشیم 
  // if (!decUser || !decUser.sub) console.log("User ID not found");
  // console.log(decUser.sub);

  const response = await getDataFullUser(); // ارسال userId و توکن به API
  // console.log(response.data.data);
  return response.data.data;
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      state.isAuthenticated = checkTokenValidity(action.payload);
      state.decodedUser = decodeToken(action.payload); // دیکد کردن و ذخیره اطلاعات
      localStorage.setItem("COact", action.payload);
    },
    clearAccessToken: (state) => {
      state.accessToken = null;
      state.isAuthenticated = false;
      state.user = null;
      state.decodedUser = null;
      localStorage.removeItem("COact");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { setAccessToken, clearAccessToken } = authSlice.actions;
export default authSlice.reducer;

